// extracted by mini-css-extract-plugin
export default {"avatar":"styles_avatar_qqHiG","image":"styles_image_cAn4l","icon":"styles_icon_MSyNu","defaultUser":"styles_default-user_IPTD1"};